// util.js
import axios from "axios";


export const portalUrl = '';


/* =========================
   LIFERAY AUTH HEADERS
   ========================= */
const liferayHeaders = {
  "X-CSRF-Token": window.Liferay?.authToken,
  "Content-Type": "application/json",
  Accept: "application/json",
};


/* =========================
   AUTH FETCH HELPER
   ========================= */
async function authFetch(url) {
  const resp = await fetch(url, {
    method: "GET",
    credentials: "include",
    headers: liferayHeaders,
  });
  if (!resp.ok) {
    throw new Error(`API failed: ${resp.status}`);
  }
  return resp.json();
}


/* =========================
   GET TENDERS
   ========================= */
export async function getTenders(page, pageSize) {
  const path = window.location.pathname;


  const sortOrder = path === "/tender-archive" ? "id:asc" : "dateCreated:desc";
  const url =
    `${portalUrl}/o/c/tendersmasters` +
    `?page=${page}` +
    `&pageSize=${pageSize}` +
    `&sort=${sortOrder}`;


  const json = await authFetch(url);
  return {
    items: json.items ?? [],
    totalCount: json.totalCount ?? 0,
  };
}


/* =========================
   GET TENDER DOCUMENTS
   ========================= */
export async function getTenderDocs(tenderId) {
  const url = `${portalUrl}/o/c/tenderdocuments/?filter=tendersId eq ${tenderId}`;
  const json = await authFetch(url);
  return Array.isArray(json.items) ? json.items : [];
}


/* =========================
   GET AMENDMENT DOCUMENTS
   ========================= */
export async function getAmmendmentDocs(tenderId) {
  const url = `${portalUrl}/o/c/tenderammendments/?filter=tendersId eq ${tenderId}`;
  const json = await authFetch(url);
  return Array.isArray(json.items) ? json.items : [];
}


/* =========================
   DATE FORMATTER
   ========================= */
export function formatDate(dateString) {
  if (!dateString) return "—";
  const d = new Date(dateString);
  if (isNaN(d)) return "—";
  const day = String(d.getDate()).padStart(2, "0");
  const month = d.toLocaleString("default", { month: "short" });
  const year = d.getFullYear();
  return `${day}-${month}-${year}`;
}


/* =========================
   GET TENDERS FOR SEARCH
   ========================= */
export async function getTendersForSearch(page, pageSize, search = "") {
  const safeSearch = search.trim().replace(/'/g, "");
  if (!safeSearch) {
    return { items: [], totalCount: 0 };
  }


  const filter =
    `contains(descriptionEnglish,'${safeSearch}')` +
    ` or contains(tenderRefNo,'${safeSearch}')` +
    ` or contains(issuedBy,'${safeSearch}')`;


  const url =
    `${portalUrl}/o/c/tendersmasters` +
    `?page=${page}` +
    `&pageSize=${pageSize}` +
    `&filter=${encodeURIComponent(filter)}`;


  const res = await fetch(url, {
    credentials: "include",
    headers: liferayHeaders,
  });


  if (!res.ok) {
    throw new Error(`Search API failed: ${res.status}`);
  }
  return res.json();
}
